import PageHeader from '../../shared/PageHeader'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import DiagnosisStatisticsReport from './reports/emr/DiagnosisStatisticsReport'
import OrderItemStatisticsReport from './reports/emr/OrderItemStatisticsReport'
import ConsultationReport from './reports/emr/ConsultationReport'
import PrescriptionReport from './reports/emr/PrescriptionReport'
import EMRReport from './reports/emr/EMRReport'
import OpenEMRReport from './reports/emr/OpenEMRReport'

import CustomTabs from '../../shared/CustomTabs'

export const patientReportTabs = t => [
  {
    name: t('Diagnosis Statistics Report'),
    content: <DiagnosisStatisticsReport />,
  },
  {
    name: t('Order Item Statistics Report'),
    content: <OrderItemStatisticsReport />,
  },
  {
    name: t('Consultation Report'),
    content: <ConsultationReport />,
  },
  {
    name: t('Prescription Report'),
    content: <PrescriptionReport />,
  },
  {
    name: t('EMR Report'),
    content: <EMRReport />,
  },
  {
    name: t('Open EMR Report'),
    content: <OpenEMRReport />,
  },
]

const EMRReports = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const prevActiveTab = state?.activeInvoiceTabIndex || 0

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <div className="flex items-center justify-between">
        <PageHeader
          title={t('Clinical EMR Reports')}
          iconSize={20}
          Icon={i18n.language === 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
          onIconClick={() => navigate(-1)}
        />
      </div>

      <div className="mt-2 w-full h-full">
        <CustomTabs
          tabs={patientReportTabs(t)}
          activeTabIndex={prevActiveTab}
        />
      </div>
    </div>
  )
}

export default EMRReports
